<template>
  <div>
    <h1>New Speaker</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>

    <SpeakerForm
      :handle-submit="onSendForm"
      :values="item"
      :errors="violations" />

    <router-link
      :to="{ name: 'SpeakerList' }"
      class="btn btn-primary mt-3">Back to list</router-link>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import SpeakerForm from './Form';

const { mapFields } = createHelpers({
    getterType: 'speaker/create/getField',
    mutationType: 'speaker/create/updateField',
});

export default {
  components: {
    SpeakerForm,
  },

  data () {
    return {
      item: {},
    };
  },

  computed: {
    ...mapFields([
      'error',
      'isLoading',
      'created',
      'violations',
    ]),
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return;
      }

      this.$router.push({ name: 'SpeakerList', params: { id: created['@id'] } });
    }
  },

  methods: {
    ...mapActions('speaker/create', [
      'create',
    ]),

    onSendForm () {
      this.create(this.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/speaker/Create.vue